module.exports = __webpack_public_path__ + "img/exclamation.8c50aa54.svg";